<script setup lang="ts">
const props = defineProps<{
  text?: string
  disabled?: boolean
  link?: boolean
  size?: string
  label?: boolean
  outline?: boolean
  secondary?: boolean
  purple?: boolean
}>()

const { pending } = storeToRefs(useProjectStore())

const isStyled = computed(
  () => props.outline || props.secondary || props.purple,
)
</script>

<template>
  <NuxtLink
    v-if="link"
    :class="{
      'cursor-not-allowed bg-secondary-gray-400 text-secondary-gray-600':
        disabled && !label,
      'cursor-not-allowed opacity-40': disabled && label,
      'px-spacing-sm py-spacing-sm sm:px-spacing-lg sm:py-spacing-sm2':
        size === 'small' && !label,
      'px-spacing-xs py-spacing-xs sm:px-spacing-md sm:py-spacing-sm':
        size === 'xs' && !label,
      'px-spacing-lg py-spacing-sm2': !size && !label,
      'secu-body-small-bold rounded-full': !label,
      'secu-body-micro gap-1 rounded-lg px-spacing-sm py-0.5': label,
      'border-2 border-transparent bg-primary-navyblue-900 text-white':
        isStyled && !secondary && !purple && !outline,
      'border-2 border-primary-navyblue-900 text-primary-navyblue-900':
        isStyled && !secondary && !purple && outline,
      'border-2 border-transparent bg-secondary-gray-100 text-secondary-gray-600':
        isStyled && secondary && !outline,
      'border-2 border-secondary-gray-400 text-secondary-gray-600':
        isStyled && secondary && outline,
      'border-2 border-transparent bg-accent-purple-100 text-accent-purple-600':
        isStyled && purple && !outline,
      'border-2 border-accent-purple-400 text-accent-purple-600':
        isStyled && purple && outline,
    }"
    class="flex items-center justify-center hover:opacity-90">
    <slot />{{ text }}
  </NuxtLink>
  <button
    v-else
    :disabled
    :class="{
      'cursor-not-allowed bg-secondary-gray-400 text-secondary-gray-600':
        disabled && !label,
      'cursor-not-allowed opacity-40': disabled && label,
      'h-12': pending && !label,
      'px-spacing-sm py-spacing-sm sm:px-spacing-lg sm:py-spacing-sm2':
        size === 'small' && !label,
      'px-spacing-xs py-spacing-xs sm:px-spacing-md sm:py-spacing-sm':
        size === 'xs' && !label,
      'px-spacing-lg py-spacing-sm2': !size && !label,
      'secu-body-small-bold rounded-full': !label,
      'secu-body-micro gap-1 rounded-lg px-spacing-sm py-0.5': label,
      'border-2 border-transparent bg-primary-navyblue-900 text-white':
        isStyled && !secondary && !purple && !outline,
      'border-2 border-primary-navyblue-900 text-primary-navyblue-900':
        isStyled && !secondary && !purple && outline,
      'border-2 border-transparent bg-secondary-gray-100 text-secondary-gray-600':
        isStyled && secondary && !outline,
      'border-2 border-secondary-gray-400 text-secondary-gray-600':
        isStyled && secondary && outline,
      'border-2 border-transparent bg-accent-purple-100 text-accent-purple-600':
        isStyled && purple && !outline,
      'border-2 border-accent-purple-400 text-accent-purple-600':
        isStyled && purple && outline,
    }"
    class="flex items-center justify-center hover:opacity-90">
    <slot /><span :class="!label ? 'min-h-5' : ''">{{ text }}</span>
  </button>
</template>
